import { render } from "./SortableCol.vue?vue&type=template&id=28509891"
import script from "./SortableCol.vue?vue&type=script&lang=js"
export * from "./SortableCol.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__